import { TableCell as MuiTableCell, TableSortLabel as MuiTableSortLabel, styled } from '@mui/material'

import type { TableColumn, TableRow } from '~/features/guild/components/table/types'

export const TableCell = <T extends TableRow<T, Props>, Props = {}>(props: {
  column: TableColumn<T, Props>
  row: T
}) => (
  <MuiTableCell
    align={props.column.bodyCellAlign}
    width={props.column.columnWidth}
    height={props.column.bodyHeight}
    sx={props.column.bodyCellSx}
  >
    {props.column.renderBodyCell ? props.column.renderBodyCell({ row: props.row }) : props.row[props.column.field]}
  </MuiTableCell>
)

/**
 * 默认表头 span 元素样式
 */
const HeaderCellInner = styled('span')`
  font-size: 14px;
  font-weight: bold;
`

/**
 * 构建表头
 * @param column 列配置
 * @param tableProps 组件内回调函数的参数传递
 * @returns
 */
export const HeaderCell = <T extends TableRow<T, Props>, Props = {}>(props: {
  column: TableColumn<T, Props>
  tableProps?: Props
}) => {
  // 如果没有排序器
  if (!props.column.sorter) {
    return props.column.renderHeaderCell ? (
      // 要么返回自定义渲染的表头单元格
      <>{props.column.renderHeaderCell({ column: props.column, props: props.tableProps })}</>
    ) : (
      // 要么返回默认的表头单元格
      <HeaderCellInner>{props.column.headerTitle}</HeaderCellInner>
    )
  }

  // 否则，返回带有排序器的表头单元格
  return (
    <MuiTableSortLabel
      // 如果当前列被排序
      active={props.column.sorter.orderBy === props.column.field.toString()}
      // 设置排序方向
      direction={props.column.sorter.orderBy === props.column.field.toString() ? props.column.sorter.order : 'asc'}
      // 设置点击事件
      onClick={(e) =>
        props.column.sorter &&
        props.column.sorter.onSort &&
        props.column.sorter.onSort({ event: e, column: props.column, props: props.tableProps })
      }
    >
      {props.column.renderHeaderCell ? (
        // 要么返回自定义渲染的表头单元格
        props.column.renderHeaderCell({ column: props.column, props: props.tableProps })
      ) : (
        // 要么返回默认的表头单元格
        <HeaderCellInner>{props.column.headerTitle}</HeaderCellInner>
      )}
    </MuiTableSortLabel>
  )
}
